import { createContext, use, type ReactNode } from 'react';
import type { RuntimeConfig } from './runtime-config';

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export function RuntimeConfigProvider({ value, children }: { value: RuntimeConfig; children: ReactNode }) {
  return <RuntimeConfigContext value={value}>{children}</RuntimeConfigContext>;
}

export function useRuntimeConfig(): RuntimeConfig {
  const cfg = use(RuntimeConfigContext);
  if (!cfg) throw new Error('useRuntimeConfig must be used inside <RuntimeConfigProvider>');
  return cfg;
}
